import { render, staticRenderFns } from "./dlgSpecial.vue?vue&type=template&id=b5627b44"
import script from "./dlgSpecial.vue?vue&type=script&lang=js"
export * from "./dlgSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports